import { __extends } from "tslib";
import { deserializeAws_json1_1GetDocumentTextDetectionCommand, serializeAws_json1_1GetDocumentTextDetectionCommand } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetDocumentTextDetectionCommand = /** @class */ (function (_super) {
    __extends(GetDocumentTextDetectionCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetDocumentTextDetectionCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetDocumentTextDetectionCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetDocumentTextDetectionCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1GetDocumentTextDetectionCommand(input, context);
    };
    GetDocumentTextDetectionCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1GetDocumentTextDetectionCommand(output, context);
    };
    return GetDocumentTextDetectionCommand;
}($Command));
export { GetDocumentTextDetectionCommand };
//# sourceMappingURL=GetDocumentTextDetectionCommand.js.map